import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../../utils/firebase-utils';

import MobileHeader from '../../components/MobileHeader/MobileHeader';
import ChoiceBox from '../../components/ChoiceBox/ChoiceBox';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import Input from 'react-bootstrap/lib/Input';

import FormSection from '../../components/FormSection/FormSection';
import FormGroup from '../../components/FormGroup/FormGroup';

const ProfileNotifications = React.createClass({
	mixins: [LinkedStateMixin],

	contextTypes: {
		history: React.PropTypes.object.isRequired
	},

	render() {
		return (
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='profile'
					title='Notifications'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content bg-gray">

					<FormSection>
						<FormGroup>
							<ChoiceBox
								label="Notice from Albert to email"
								type="checkbox"
							/>
						</FormGroup>
						<FormGroup>
							<ChoiceBox
								label="Send reports to my parents"
								type="checkbox"
							/>
						</FormGroup>
					</FormSection>

					<FormSection>
						<FormGroup
							label="Parents email"
						>
							<Input type="email"/>
						</FormGroup>
					</FormSection>
				</div>
			</div>
		);
	}
});

export default ProfileNotifications;


/** WEBPACK FOOTER **
 ** ./src/screens/profile/ProfileNotifications.js
 **/